import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  // ===============================
  // BREAKPOINTS (MOBILE-FIRST)
  // ===============================
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },

  // ===============================
  // GLOBAL TYPOGRAPHY
  // (WAEC / JAMB STANDARD)
  // ===============================
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",

    // Base font size (IMPORTANT)
    fontSize: 14, // calmer than MUI default

    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,

    // ---------- HEADINGS ----------
    h1: {
      fontSize: "1.8rem",
      fontWeight: 600,
      lineHeight: 1.25,
    },
    h2: {
      fontSize: "1.6rem",
      fontWeight: 600,
      lineHeight: 1.25,
    },
    h3: {
      fontSize: "1.4rem",
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.1rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
    },

    // ---------- BODY TEXT ----------
    body1: {
      fontSize: "1rem", // ≈ 16px (WAEC/JAMB)
      fontWeight: 400,
      lineHeight: 1.6,
      "@media (max-width:600px)": {
        fontSize: "0.95rem", // ≈ 15px mobile
        lineHeight: 1.65,
      },
    },

    body2: {
      fontSize: "0.95rem", // ≈ 15px
      fontWeight: 400,
      lineHeight: 1.6,
      "@media (max-width:600px)": {
        fontSize: "0.9rem",
      },
    },

    // ---------- BUTTONS ----------
    button: {
      fontSize: "0.9rem",
      fontWeight: 500,
      textTransform: "none", // removes aggressive ALL CAPS
      letterSpacing: "0.02em",
    },

    // ---------- CAPTIONS / LABELS ----------
    caption: {
      fontSize: "0.8rem",
      fontWeight: 400,
    },

    overline: {
      fontSize: "0.75rem",
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: "0.08em",
    },
  },

  // ===============================
  // COMPONENT-SPECIFIC TUNING
  // (CALMER UI, LESS BOLD)
  // ===============================
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#ffffff",
          color: "#1a1a1a",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        fontWeight: 400,
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          paddingLeft: 16,
          paddingRight: 16,
          minHeight: 40,
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "0.95rem",
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "0.9rem",
        },
        head: {
          fontWeight: 600,
        },
      },
    },
  },
});

export default theme;
